export default "__VITE_ASSET__CmtW8aBH__"